import React, {Component} from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

class ItemSize extends Component {
    render() {
        const {lazyload, meta} = this.props
        const { dimension = {} } = Object.assign({}, meta)
        const { equivalent = {} } = Object.assign({}, dimension)
        const { width, height } = Object.assign({}, equivalent)

        return (
            <td className='ItemSize'>
                {
                    lazyload ? 
                    <LazyLoad>
                        {this.props.size}
                        {
                            width && height &&
                            <span className='d-block' style={{ color: '#ff4d4f', whiteSpace: 'nowrap', fontWeight: 600 }}>
                                {`${width}x${height} in`}
                            </span>
                        }
                    </LazyLoad> : 
                    <>
                        {this.props.size}
                        {
                            width && height &&
                            <span className='d-block' style={{ color: '#ff4d4f', whiteSpace: 'nowrap', fontWeight: 600 }}>
                                {`${width}x${height} in`}
                            </span>
                        }
                    </>
                }
                
            </td>
        )
    }
}

ItemSize.propTypes = {
    size: PropTypes.string.isRequired,
}

export default ItemSize
